import { Navigate, useParams } from "react-router-dom";

/**
 * Friendly alias routes: /client-views/:slug/* → /v/:slug/*
 * Keeps Midpoint Media (and other Client Views) reachable via platform-style paths.
 */
const ClientViewPublicRedirect = () => {
  const { slug, "*": rest } = useParams();
  const suffix = rest ? `/${rest}` : "";
  return <Navigate to={`/v/${slug}${suffix}`} replace />;
};

export default ClientViewPublicRedirect;
